import * as React from "react";
import { SVGProps } from "react";
const SvgBookmarkOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 3c1.1 0 2 .9 2 2v22.9c0 .4-.2.7-.6.9-.4.2-.8.1-1.1-.1L16.6 24c-.4-.3-.9-.3-1.3 0l-5.7 4.7c-.3.2-.7.3-1.1.1-.4-.2-.5-.5-.5-.9V5c0-1.1.9-2 2-2h12Zm0 22.86V5H10v20.778l4.1-3.378c1.058-.794 2.449-.831 3.601-.064l.171.12L22 25.86Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBookmarkOutline;
